'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { Container, Row, Col } from 'reactstrap';
import CtaBtn from './CtaBtn';
import { getI18nUtils } from '../i18n/i18n-utils';

const FirstJobBanner = ({ dictionary }) => {
  const { locale } = useParams();
  const { formatMessage } = getI18nUtils(dictionary);

  const isCareers = process.env.NEXT_PUBLIC_APP === 'synergiecareers.be';
  const firstJobHref = isCareers
    ? `/${locale}/candidates/my-first-job`
    : `https://www.synergiecareers.be/${locale}/candidates/my-first-job`;
  const jobsHref = isCareers ? `/${locale}/jobs/` : `https://www.synergiecareers.be/${locale}/jobs/`;
  const externalLinkProps = isCareers ? {} : { target: '_blank' as const, rel: 'noopener noreferrer' };

  return (
    <div id="firstJobBanner">
      <Container className="h-100">
        <Row className="h-100">
          <Col md={5} className="h-100 d-flex align-items-center">
            <div className="bannerText text-white">
              <h2 className="font-weight-bold">{formatMessage({ id: 'hp-banner-job-experience' })}</h2>
              <p className="mb-3">{formatMessage({ id: 'hp-banner-subtitle' })}</p>
              <div className="d-flex gap-2 flex-wrap">
                <Link href={firstJobHref} {...externalLinkProps} style={{ textDecoration: 'none' }}>
                  <CtaBtn className="cta red" type="button">
                    {formatMessage({ id: 'hp-banner-discover' })}
                  </CtaBtn>
                </Link>
                <Link href={jobsHref} {...externalLinkProps} style={{ textDecoration: 'none' }}>
                  <CtaBtn className="btn-outline-white" type="button">
                    {formatMessage({ id: 'hp-banner-discover-jobs' })}
                  </CtaBtn>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FirstJobBanner;
